import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_16g27gl0kb: FaireBrandEntity = {
  token: "b_16g27gl0kb",
  type: "brand",
  name: "CHAIMATI",
  avatarUrl:
    "https://cdn.faire.com/fastly/370d3ebbc7007ce5389fda12a318465a343a4fa1a9a5f306618e01015f142b46.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/811746270ea711a485d1058cd2c623b57f59b13eb9c41031909949c3caf4ec9a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/370d3ebbc7007ce5389fda12a318465a343a4fa1a9a5f306618e01015f142b46.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/811746270ea711a485d1058cd2c623b57f59b13eb9c41031909949c3caf4ec9a.png",
  location: "Boston, MA, USA",
  minimumOrderDollars: 50,
  rating: 4.5,
  reviewCount: 4,
  isInsider: true,
  description:
    "CHAIMATI is a modern chai company reimagining one of the world’s most loved beverages for today’s cafés, retailers, and homes.\n\nRooted in authentic Indian chai culture and crafted for contemporary lifestyles, our blends combine premium ingredients, elevated flavor profiles, and effortless preparation.\n\nFrom instant chai lattes to experiential beverage programs, we believe chai should be more than a drink — it should be a daily ritual.\n\nInspired by India. Made for the world.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.288Z",
    importedBy: "entity-db-cli",
  },
};
